/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import { LoggerModule } from "@vlinder-web/logger-module-react";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { VApplication } from "../../../application";
import { StorageModule } from "@vlinder-web/storage-module-react";
import toast from "react-hot-toast";
import { CREATE_MULTI_BOX } from "../graphql/createMultiBox.mutation";
import { MULTI_REG_BOX } from "../graphql/multiregisterBox.mutation";

const log: any = LoggerModule?.getInstance();
const storageService = StorageModule.getInstance();

const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export interface ICreateMultiBoxMethods extends IPluginMethodMap {
  CreateMultiBox(args: any): Promise<any>;
}

export class CreateMultiBoxService implements IAgentPlugin {
  readonly methods: ICreateMultiBoxMethods;

  constructor() {
    this.methods = {
      CreateMultiBox: this.CreateMultiBox.bind(this),
    };
  }

  async CreateMultiBox(args: any) {
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");
    try {
      console.log(
        "args12345create",
        args,
        this.transformData(args?.createMulti)
      );
      if (client) {
        let variables: any = {
          data: this.transformData(args?.createMulti),
        };
        const res = await client.mutate({
          mutation: CREATE_MULTI_BOX,
          variables: variables,
          fetchPolicy: "no-cache",
        });
        if (res?.data) {
          let variables1 = this.transformResData(args?.event, args?.items, res);
          console.log("args12345create", variables1);
          const res1 = await client.mutate({
            mutation: MULTI_REG_BOX,
            variables: variables1,
            fetchPolicy: "no-cache",
          });
          if (res1?.data) {
            const paymentUrl =
              res1?.data?.multiRegisterPayment?.data?.session[
                "payment-hosted-url"
              ];
            if (paymentUrl) {
              window.location.href = paymentUrl;
              console.log(`Redirecting to: ${paymentUrl}`);
              return {
                ...res1?.data?.multiRegisterPayment,
                redirection: true,
              };
            }
            toast.success("Costumes Created !");
            return {
              ...res1?.data?.multiRegisterPayment,
              redirection: false,
            };
          }
          toast.error("Box created but payment failed!");
          return true;
        }
      }
    } catch (err: any) {
      let _display_message =
        err?.graphQLErrors &&
        Array.isArray(err?.graphQLErrors) &&
        err?.graphQLErrors.find((item: any) => item.extensions);
      if (_display_message?.extensions?.display_message) {
        toast.error(
          _display_message?.extensions?.display_message ??
            "Something went wrong"
        );
        throw Error(_display_message?.extensions?.display_message);
      }

      throw err;
    }
  }

  private transformResData(event, items, res1) {
    const groupId = res1.data.createMultiBox[0]?.groupId;

    const splitMap = res1.data.createMultiBox.map((entry, index) => {
      const mappedItem = {
        amount: items[index]?.enteredAmount ?? 0,
        costumeId: entry.payOrder.box[0].costumeID,
        payOrder: entry.payOrder.id,
      };
      if (items[index]?.selectedDiscount) {
        mappedItem.discountCode = items[index].selectedDiscount;
      }
      return mappedItem;
    });

    return {
      data: {
        amount: event.amount,
        currency: event.currency,
        groupId,
        groupPayment: true,
        splitMap,
        payorder: res1.data.createMultiBox[0]?.payOrder.id,
      },
    };
  }

  private transformData(inputData) {
    return inputData.map((entry) => {
      if (Array.isArray(entry.items)) {
        let data = {
          presentation: entry.presentationID,
          section: entry.sectionID,
          items: entry.items,
          referal: entry.referal,
        };
        if (entry?.availableTime) {
          data.availableTime = entry?.availableTime;
        }
        if (entry?.address) {
          data.address = entry?.address;
        }
        return data;
      }
      let data = {
        presentation: entry.items.presentation,
        section: entry.items.section,
        items: entry.items.items,
        referal: entry.items.referal,
      };
      if (entry?.items?.availableTime) {
        data.availableTime = entry?.items?.availableTime;
      }
      if (entry?.items?.address) {
        data.address = entry?.items?.address;
      }
      return data;
    });
  }
}
